// Compact monthly fee summary for narrow dashboard columns: potential fees and
// realized month earnings as tight chip rows with small captions.
import { Box, Text, useColorModeValue } from "@chakra-ui/react";
import { FeeChips } from "./FeeSections";

/**
 * Renders a compact potential-fees and month-earnings summary; hides the
 * potential row when empty and shows a "0" fallback for earnings.
 * @param {Object} props - potential ([{symbol, amount}]), month ([{symbol, amount}])
 * @returns {React.ReactElement}
 */
export default function CompactFees({ potential, month }) {
  const captionColor = useColorModeValue("secondaryGray.600", "secondaryGray.400");
  const valueColor = useColorModeValue("secondaryGray.900", "white");
  return (
    <Box mt="12px" w="100%">
      {potential?.length > 0 && (
        <Box mb="8px">
          <Text fontSize="10px" textTransform="uppercase" fontWeight="600" color={captionColor}
            mb="3px" textAlign="center">Potentiel ce mois</Text>
          <FeeChips fees={potential} colorScheme="orange" />
        </Box>
      )}
      <Box>
        <Text fontSize="10px" textTransform="uppercase" fontWeight="600" color={captionColor}
          mb="3px" textAlign="center">Gains du mois</Text>
        {month?.length
          ? <FeeChips fees={month} colorScheme="green" />
          : <Text textAlign="center" fontSize="lg" fontWeight="800" color={valueColor}>0</Text>}
      </Box>
    </Box>
  );
}
